import type { GetterTree, Store } from "vuex";
import type { State } from "@/store/state";
import type { AssetState } from "./state";
import type { Asset } from "@/interfaces/assets";

export const getters: GetterTree<AssetState, State> = {
  assets: (state): Asset[] => state.assets,
};

const NS = "assets/";

export const readAssets = (store: Store<State>) =>
  store.getters[`${NS}assets`] as Asset[];
